import * as React from 'react';
import { Dropdown, DropdownMenuItemType } from '@fluentui/react/lib/Dropdown';
import { throwError, summaryScreen, toggleLoading, clearError} from '../actions/navigationWorker';
import { GetSetting } from '../actions/settingsWorker';
import { GetItemText, GetDependOptions } from '../actions/helper';
import { TextField } from '@fluentui/react/lib/TextField';
import { DatePicker, IDatePickerStrings, DayOfWeek } from '@fluentui/react';

let doc_types = [{ key: 'Header', text: 'Document Type', itemType: DropdownMenuItemType.Header }];
let doc_subtypes = [{ key: 'Header', text: 'Document Subtype', itemType: DropdownMenuItemType.Header }];
let permissions = [{ key: 'Header', text: 'Permission', itemType: DropdownMenuItemType.Header }];
const group_name = 'entity_note';

const DayPickerStrings: IDatePickerStrings = {
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortDays: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    goToToday: 'Go to today',
    prevMonthAriaLabel: 'Go to previous month',
    nextMonthAriaLabel: 'Go to next month',
    prevYearAriaLabel: 'Go to previous year',
    nextYearAriaLabel: 'Go to next year',
    invalidInputErrorMessage: 'Invalid date format.',
    isOutOfBoundsErrorMessage: 'Date is out of bounds, please re-enter'
};

// Responsive dropdown configuration for better mobile UX
const responsiveDropdownProps = {
	calloutProps: { 
		calloutMaxHeight: 400,
		doNotLayer: false,
		calloutMinWidth: 300,
		preventDismissOnScroll: false,
		preventDismissOnResize: false,
		preventDismissOnLostFocus: false
	},
	dropdownWidth: "auto" as const,
	responsiveMode: 999,
	styles: {
		callout: {
			maxHeight: '60vh',
			minWidth: '300px',
			width: 'auto',
			backgroundColor: '#ffffff',
			selectors: {
				'.ms-Callout-main': {
					maxHeight: '60vh',
					minWidth: '300px',
					overflow: 'auto' as 'auto',
					backgroundColor: '#ffffff',
					scrollBehavior: 'auto' as 'auto'
				}
			}
		},
		dropdownItemsWrapper: {
			maxHeight: '50vh',
			minWidth: '300px',
			backgroundColor: '#ffffff',
			scrollBehavior: 'auto' as 'auto'
		},
		dropdownItems: {
			minWidth: '300px',
			backgroundColor: '#ffffff'
		},
		dropdownItem: {
			backgroundColor: '#ffffff',
			minHeight: '36px'
		},
		dropdownItemSelected: {
			backgroundColor: '#f3f2f1',
			minHeight: '36px'
		},
		dropdownItemSelectedAndDisabled: {
			backgroundColor: '#f3f2f1',
			minHeight: '36px'
		}
	}
};

export interface AppProps {
   hide: boolean;
}

export interface AppState {
    doc_subtypes: any,
    doc_categories: any,
    subject: string,
    selectedType: string,
    selectedSubType: string,
    selectedPermission: string,
    selectedAccess: Array<string>,
    selectedCategory: Array<string>
    invalid_subject: string,
    excludeEmailFromNote: boolean,
    customNoteBody: string,
    noteDate: Date | null,
    firstDayOfWeek?: DayOfWeek
}

class NoteProperties extends React.Component<AppProps, AppState> {
    private checkSubjectReloadInterval: any;
    private originalScrollIntoView: any;

    constructor(props) {
        super(props);
        let doc_categories = JSON.parse(localStorage.getItem('doc_category_results')) || [];

        this.handleSubjectChange = this.handleSubjectChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleSubTypeChange = this.handleSubTypeChange.bind(this);
        this.handlePermissionChange = this.handlePermissionChange.bind(this);
        this.handleAccessChange = this.handleAccessChange.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.handleCustomNoteBodyChange = this.handleCustomNoteBodyChange.bind(this);
        this.handleNoteDateChange = this.handleNoteDateChange.bind(this);
        this.get_docnote_type();
        this.get_docnote_sub_type();
        this.get_permissions();
        const select_perm = GetSetting('Permission_default', null);
        const savedNoteDate = sessionStorage.getItem('note_date');
        const initialNoteDate = savedNoteDate ? new Date(savedNoteDate) : (Office.context.mailbox ? Office.context.mailbox.item.dateTimeCreated : new Date());
        
        this.state = {
            doc_subtypes: doc_subtypes,
            doc_categories: doc_categories,
            subject: (Office.context.mailbox ? Office.context.mailbox.item.subject.replace(/[*|?:"<>\\\/]/gi, ' ') : ''),
            selectedType:  GetSetting('entity_note_type_default', null),
            selectedSubType: GetSetting('entity_note_subtype_depend_default', null),
            selectedPermission: GetSetting('Permission_default', null) === '' ? '4' : select_perm,
            selectedAccess: [],
            selectedCategory: [],
            invalid_subject: 'Invalid Subject please re-enter',
            excludeEmailFromNote: sessionStorage.getItem("exclude_email_from_note") === "true",
            customNoteBody: sessionStorage.getItem("custom_note_body") || "",
            noteDate: initialNoteDate,
            firstDayOfWeek: DayOfWeek.Sunday
        };
        toggleLoading(false);
        
        // Disable auto-scroll on hover in dropdowns by overriding scrollIntoView
        this.disableAutoScrollInDropdowns();
        
        // Prevent focus changes on hover
        this.preventDropdownFocusOnHover();
    }

    preventDropdownFocusOnHover = () => {
        // Add event listener to prevent focus on hover in dropdowns
        document.addEventListener('mousemove', (e) => {
            const target = e.target as HTMLElement;
            if (target && typeof target.closest === 'function') {
                const dropdownItem = target.closest('.ms-Dropdown-item');
                if (dropdownItem) {
                    // Prevent focus by stopping the event
                    e.stopPropagation();
                    // Remove focus from the item if it has it
                    const focusedElement = document.activeElement as HTMLElement;
                    if (focusedElement && focusedElement.closest('.ms-Dropdown-item')) {
                        focusedElement.blur();
                    }
                }
            }
        }, true);
    }

    disableAutoScrollInDropdowns = () => {
        // Save original scrollIntoView
        this.originalScrollIntoView = Element.prototype.scrollIntoView;
        
        // Override scrollIntoView to prevent auto-scrolling on hover
        Element.prototype.scrollIntoView = function(arg?: any) {
            // Check if element is inside a dropdown or callout
            if (this.closest) {
                const inDropdown = this.closest('.ms-Dropdown-items') || 
                                 this.closest('.ms-Dropdown-itemsWrapper') ||
                                 this.closest('.ms-Callout-main') ||
                                 this.closest('.ms-Dropdown-callout') ||
                                 this.classList?.contains('ms-Dropdown-item');
                
                if (inDropdown) {
                    // Block ALL scrollIntoView calls inside dropdowns
                    return;
                }
            }
            // Allow scrollIntoView for other cases
            return this.originalScrollIntoView.call(this, arg);
        };
    }

    restoreScrollIntoView = () => {
        if (this.originalScrollIntoView) {
            Element.prototype.scrollIntoView = this.originalScrollIntoView;
        }
    }

    handleSubjectChange = (_event, item) => {
        sessionStorage.setItem('subject', item);
        this.setState({subject: item});
    }

    handleTypeChange = (_event, item) => {
        sessionStorage.setItem('doc_type', JSON.stringify({ id: item.key, name: item.text }));

        doc_subtypes = [];
        doc_subtypes.push({ key: 'Header', text: 'Document Subtype', itemType: DropdownMenuItemType.Header });

        const data = GetDependOptions(group_name, item.key);
        if (data && data.length > 0) {
            for (let i = 0, l = data.length; i < l; i++) {
                doc_subtypes.push({ key: data[i].key, text: data[i].text, itemType: DropdownMenuItemType.Normal});
            }
        }

        sessionStorage.setItem('doc_subtype', JSON.stringify({}));
        this.setState({doc_subtypes: doc_subtypes, selectedType: item.key});
    }

    handleSubTypeChange = (_event, item) => {
        sessionStorage.setItem('doc_subtype', JSON.stringify({id: item.key, name: item.text}));
        this.setState({selectedSubType: item.key});
    }

    handlePermissionChange = (_event, item) => {
        sessionStorage.setItem('doc_permission', JSON.stringify({id: item.key, name: item.text}));
        this.setState({selectedPermission: item.key});
    }

    handleAccessChange = (_event, item) => {
        let doc_access = JSON.parse(sessionStorage.getItem('doc_access')) || [];
        let selected_access = this.state.selectedAccess ? this.copyArray(this.state.selectedAccess) : [];
        if (item.selected) {
            doc_access.push({id: item.key, name: item.text});
            selected_access.push(item.key);
        } else {
            doc_access.pop({id: item.key, name: item.text});
            const currIndex = selected_access.indexOf(item.key);
            if (currIndex > -1) {
                selected_access.splice(currIndex, 1);
            }
        }
        sessionStorage.setItem('doc_access', JSON.stringify(doc_access));
        this.setState({selectedAccess: selected_access});
    }

    handleCategoryChange = (_event, item) => {
        let doc_category = JSON.parse(sessionStorage.getItem('doc_category')) || [];
        let selected_category = this.state.selectedCategory ? this.copyArray(this.state.selectedCategory) : [];
        if (item.selected) {
            doc_category.push({id: item.key, name: item.text});
            selected_category.push(item.key);
        } else {
            doc_category.pop({id: item.key, name: item.text});
            const currIndex = selected_category.indexOf(item.key);
            if (currIndex > -1) {
                selected_category.splice(currIndex, 1);
            }
        }
        sessionStorage.setItem('doc_category', JSON.stringify(doc_category));
        this.setState({selectedCategory: selected_category});
    }

    handleCustomNoteBodyChange = (_event, value: string) => {
        this.setState({ customNoteBody: value });
        sessionStorage.setItem('custom_note_body', value);
    }

    handleNoteDateChange = (date: Date | null | undefined) => {
        if (date) {
            this.setState({ noteDate: date });
            sessionStorage.setItem('note_date', date.toISOString());
        }
    }

    _onFormatDate = (date: Date): string => {
        if (date) {
            return (('0' + (date.getDate())).slice(-2)).toString() + '/' +
                (('0' + (date.getMonth() + 1)).slice(-2)).toString() + '/' +
                date.getFullYear().toString();
        }
        return '';
    }

    _onParseDateFromString = (value: string): Date => {
        const date = this.state.noteDate || new Date();
        const values = (value || '').trim().split('/');
        const day = values.length > 0 ? Math.max(1, Math.min(31, parseInt(values[0], 10))) : date.getDate();
        const month = values.length > 1 ? Math.max(1, Math.min(12, parseInt(values[1], 10))) - 1 : date.getMonth();
        let year = values.length > 2 ? parseInt(values[2], 10) : date.getFullYear();
        if (year < 100) {
            year += date.getFullYear() - (date.getFullYear() % 100);
        }
        return new Date(year, month, day);
    }

    public copyArray = (array: any[]): any[] => {
        const newArray: any[] = [];
        for (let i = 0; i < array.length; i++) {
            newArray[i] = array[i];
        }
        return newArray;
    }

    summary = () => {
        toggleLoading(false);
        summaryScreen();
    }

    disableNext = (): boolean => {
        let count = 0;
        if (this.state.selectedType) {
            if (this.state.selectedType.toString().length > 0) {
                count = count + 1;
            }
        }
        if (this.state.selectedPermission) {
            if (this.state.selectedPermission.toString().length > 0) {
                count = count + 1;
            }
        }
        if (this.ValidateSubject()) {
            count = count + 1;
        }
        return count !== 3;
    }

    get_docnote_type = () => {
        let data: any;
        doc_types = [{ key: 'Header', text: 'Document Type', itemType: DropdownMenuItemType.Header}];

        data = JSON.parse(localStorage.getItem(group_name + '_type_results')) || [];
        if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
             doc_types.push({ key: data[i][0], text: data[i][1], itemType: DropdownMenuItemType.Normal });
            }
        } else if (localStorage.getItem("ufields_need_loading") === "true") {
            // Data is still loading
            doc_types.push({ key: 'loading', text: 'Loading options...', itemType: DropdownMenuItemType.Normal });
        }
    }

    get_docnote_sub_type = () => {
        let data: any;
        doc_subtypes = [{ key: 'Header', text: 'Document Sub Type', itemType: DropdownMenuItemType.Header}];

        data = JSON.parse(localStorage.getItem(group_name + '_subtype_results')) || [];
        if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
             doc_subtypes.push({ key: data[i][0], text: data[i][1], itemType: DropdownMenuItemType.Normal });
            }
        } else if (localStorage.getItem("ufields_need_loading") === "true") {
            // Data is still loading
            doc_subtypes.push({ key: 'loading', text: 'Loading options...', itemType: DropdownMenuItemType.Normal });
        }
    }

    get_permissions = () => {
        permissions = [{ key: 'Header', text: 'Permission', itemType: DropdownMenuItemType.Header}];
        const data = JSON.parse(localStorage.getItem('PermissionList')) || [];
        if (data && data.length > 0) {
            data.forEach(x => {
                permissions.push({ key: x[0], text: x[1], itemType: DropdownMenuItemType.Normal});
            });
        } else if (localStorage.getItem("ufields_need_loading") === "true") {
            // Data is still loading
            permissions.push({ key: 'loading', text: 'Loading options...', itemType: DropdownMenuItemType.Normal });
        }
    }

    private ValidateSubject = (): boolean => {
        if (!this.state.subject) {
            throwError(this.state.invalid_subject);
            return false;
        }
        clearError();
        return true;
    }

    componentDidMount() {
        if (this.state.selectedSubType && this.state.selectedSubType !== 'undefined') {
            this.get_docnote_sub_type();
            this.setState({doc_subtypes: doc_subtypes});
            const text = GetItemText(group_name + '_subtype_results', this.state.selectedSubType);
            sessionStorage.setItem('doc_subtype', JSON.stringify({id: this.state.selectedSubType, name: text}));
        }
        if (this.state.selectedType) {
            const text = GetItemText(group_name + '_type_results', this.state.selectedType);
            sessionStorage.setItem('doc_type', JSON.stringify({ id: this.state.selectedType, name: text }));
        }
        if (this.state.selectedPermission) {
            let text = GetItemText('PermissionList', this.state.selectedPermission);
            let permission_id = this.state.selectedPermission;
            if (text === '') {
                sessionStorage.removeItem('Permission_default');
            }
            sessionStorage.setItem('doc_permission', JSON.stringify({id: permission_id, name: text}));
        }
        if (this.state.subject) {
            sessionStorage.setItem('subject', this.state.subject);
        }
        if (this.state.noteDate) {
            sessionStorage.setItem('note_date', this.state.noteDate.toISOString());
        }
        
        // Set up interval to check for subject reload trigger and excludeEmail changes
        this.checkSubjectReloadInterval = setInterval(() => {
            if (sessionStorage.getItem('reload_subject_from_email') === 'true') {
                const newSubject = sessionStorage.getItem('subject');
                if (newSubject && newSubject !== this.state.subject) {
                    this.setState({ subject: newSubject });
                }
                sessionStorage.removeItem('reload_subject_from_email');
            }
            
            // Check for excludeEmailFromNote changes
            const excludeEmail = sessionStorage.getItem('exclude_email_from_note') === 'true';
            if (excludeEmail !== this.state.excludeEmailFromNote) {
                this.setState({ excludeEmailFromNote: excludeEmail });
            }
            
            // Check for customNoteBody changes
            const customBody = sessionStorage.getItem('custom_note_body') || '';
            if (customBody !== this.state.customNoteBody) {
                this.setState({ customNoteBody: customBody });
            }
        }, 100);
    }

    componentWillUnmount() {
        if (this.checkSubjectReloadInterval) {
            clearInterval(this.checkSubjectReloadInterval);
        }
        // Restore original scrollIntoView behavior
        this.restoreScrollIntoView();
    }

    public ArrayToObject = (array: any[]): any => {
        let object = {};
        array.forEach(element => {
            object[element[0]] = element[1];
        });
        return object;
    }

    public render() {
        const hideDocumentNoteCategories = localStorage.getItem('hide_document_note_categories') === 'true';

        return (
            <div style={{ fontSize: '13px' }}>
                <div style={{ marginBottom: '4px' }}>
                    <TextField
                        label='Note Subject'
                        placeholder='Subject'
                        onChange={this.handleSubjectChange}
                        value={this.state.subject}
                        styles={{ 
                            root: { width: '100%' },
                            fieldGroup: { height: '32px', borderColor: '#5D3FD6', borderRadius: '6px' },
                            field: { fontSize: '13px' },
                            subComponentStyles: {
                                label: { root: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' } }
                            }
                        }}
                    />
                </div>
                <div style={{ marginBottom: '4px' }}>
                    <DatePicker
                        label='Note Date'
                        firstDayOfWeek={this.state.firstDayOfWeek}
                        strings={DayPickerStrings}
                        placeholder='Select date: DD/MM/YYYY'
                        allowTextInput={true}
                        onSelectDate={this.handleNoteDateChange}
                        value={this.state.noteDate}
                        parseDateFromString={this._onParseDateFromString}
                        formatDate={this._onFormatDate}
                        highlightCurrentMonth={true}
                        highlightSelectedMonth={true}
                        disableAutoFocus={true}
                        showMonthPickerAsOverlay={true}
                        styles={{
                            root: { width: '100%' },
                            textField: { 
                                fieldGroup: { height: '32px', borderColor: '#5D3FD6', borderRadius: '6px' },
                                field: { fontSize: '13px' },
                                subComponentStyles: {
                                    label: { root: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' } }
                                }
                            }
                        }}
                    />
                </div>
                {this.state.excludeEmailFromNote && (
                    <div style={{ marginBottom: '4px' }}>
                        <TextField
                            label="Note Body"
                            placeholder="Enter custom note content..."
                            multiline
                            rows={4}
                            value={this.state.customNoteBody}
                            onChange={this.handleCustomNoteBodyChange}
                            onBlur={(e) => this.handleCustomNoteBodyChange(null, e.target.value)}
                            required
                            styles={{
                                root: { width: '100%' },
                                fieldGroup: { borderColor: '#5D3FD6', borderRadius: '6px' },
                                field: { fontSize: '13px' },
                                subComponentStyles: {
                                    label: { root: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' } }
                                }
                            }}
                        />
                    </div>
                )}
                <div style={{ marginBottom: '4px' }}>
                    <Dropdown
                        label='* Note Type'
                        placeholder='Type'
                        onChange={this.handleTypeChange}
                        options={doc_types}
                        defaultSelectedKey={this.state.selectedType}
                        styles={{ 
                            root: { width: '100%', marginBottom: '4px' }, 
                            label: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' },
                            title: { fontSize: '13px', height: '32px', lineHeight: '28px', borderColor: '#5D3FD6', borderRadius: '6px' },
                            ...responsiveDropdownProps.styles 
                        }}
                        calloutProps={responsiveDropdownProps.calloutProps}
                        dropdownWidth={responsiveDropdownProps.dropdownWidth}
                        responsiveMode={responsiveDropdownProps.responsiveMode}
                    />
                </div>
                <div style={{ marginBottom: '4px' }}>
                    <Dropdown
                        label='Note Sub Type'
                        placeholder='Subtype'
                        onChange={this.handleSubTypeChange}
                        options={this.state.doc_subtypes}
                        disabled={this.state.doc_subtypes.length < 2}
                        defaultSelectedKey={this.state.selectedSubType}
                        styles={{ 
                            root: { width: '100%', marginBottom: '4px' },
                            label: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' },
                            title: { fontSize: '13px', height: '32px', lineHeight: '28px', borderColor: '#5D3FD6', borderRadius: '6px' },
                            ...responsiveDropdownProps.styles 
                        }}
                        calloutProps={responsiveDropdownProps.calloutProps}
                        dropdownWidth={responsiveDropdownProps.dropdownWidth}
                        responsiveMode={responsiveDropdownProps.responsiveMode}
                    />
                </div>
                <div style={{ marginBottom: '4px' }}>
                    <Dropdown
                        label='* Note Permission'
                        placeholder='Permission'
                        onChange={this.handlePermissionChange}
                        options={permissions}
                        defaultSelectedKey={this.state.selectedPermission}
                        styles={{ 
                            root: { width: '100%', marginBottom: '4px' },
                            label: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' },
                            title: { fontSize: '13px', height: '32px', lineHeight: '28px', borderColor: '#5D3FD6', borderRadius: '6px' },
                            ...responsiveDropdownProps.styles 
                        }}
                        calloutProps={responsiveDropdownProps.calloutProps}
                        dropdownWidth={responsiveDropdownProps.dropdownWidth}
                        responsiveMode={responsiveDropdownProps.responsiveMode}
                    />
                </div>
                <div style={{ marginBottom: '4px' }}>
                    <Dropdown
                        label='Note Access'
                        placeholder='Access'
                        onChange={this.handleAccessChange}
                        multiSelect
                        options={[
                                    { key: 'Header', text: 'Access', itemType: DropdownMenuItemType.Header },
                                    { key: 'is_client_access_accessible', text: 'Client Access' },
                                    { key: 'is_referrer_accessible', text: 'Referrer Access' },
                                    { key: 'is_profadviser_accessible', text: 'Prof.Adviser Access' },
                        ]}
                        defaultSelectedKeys={this.state.selectedAccess}
                        styles={{ 
                            root: { width: '100%', marginBottom: '4px' },
                            label: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' },
                            title: { fontSize: '13px', height: '32px', lineHeight: '28px', borderColor: '#5D3FD6', borderRadius: '6px' },
                            ...responsiveDropdownProps.styles 
                        }}
                        calloutProps={responsiveDropdownProps.calloutProps}
                        dropdownWidth={responsiveDropdownProps.dropdownWidth}
                        responsiveMode={responsiveDropdownProps.responsiveMode}
                    />
                </div>
                {!hideDocumentNoteCategories && (
                    <div style={{ marginBottom: '4px' }}>
                        <Dropdown
                            label='Note Categories'
                            placeholder='Categories'
                            onChange={this.handleCategoryChange}
                            multiSelect
                            options={this.state.doc_categories}
                            defaultSelectedKeys={this.state.selectedCategory}
                            styles={{ 
                                root: { width: '100%', marginBottom: '4px' },
                                label: { fontSize: '12px', fontWeight: 500, color: '#1A1F4D', marginBottom: '3px' },
                                title: { fontSize: '13px', height: '32px', lineHeight: '28px', borderColor: '#5D3FD6', borderRadius: '6px' },
                                ...responsiveDropdownProps.styles 
                            }}
                            calloutProps={responsiveDropdownProps.calloutProps}
                            dropdownWidth={responsiveDropdownProps.dropdownWidth}
                            responsiveMode={responsiveDropdownProps.responsiveMode}
                        />
                    </div>
                )}

            </div>
        );
    }
}

export default NoteProperties;
